import * as _ from 'lodash';

class JsonApiReference {
  id: number = null;
  type: string = null;

  constructor(init?: any) {
    if (!_.isNil(init)) {
      this.id = init.id;
      this.type = init.type;
    }
  }
}

export default JsonApiReference;



// WEBPACK FOOTER //
// ./common/models/jsonapi-reference.ts